import {InsuranceProvider} from "./InsuranceProvider";

export interface Contract{
    id: number,
    code: string,
    description: string,
    refundType: InsuranceRefundType,
    insuranceProvider: InsuranceProvider,
    billingType: BillingType,
    initDate: string,
    active: boolean,
    hasProcedure?: boolean,
}

export enum BillingType{
    UNIQUE_INVOICE="UNIQUE_INVOICE",
    PAYER_INVOICE="PAYER_INVOICE"
}

export enum InsuranceRefundType {
    DIRECT = 'DIRECT',
    INDIRECT = 'INDIRECT'
}